import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/announcement.svg";
var AnnouncementOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  AnnouncementOutline_default as default
};
